module.exports = __webpack_public_path__ + "static/ComplexEllipseLeft3-ea6d1e0a50c3f98ea3168c7d75958f25.png";